import * as THREE from "three";
import {Background} from "./background.js";
import {Globals} from "../../../global/globals.js";

/**
 * A background from a cubemap
 */
export class BackgroundCubemap extends Background {
    /**
     * Construct a cubemap background
     * @param {string} left The left side of the cubemap
     * @param {string} right The right side of the cubemap
     * @param {string} top The top side of the cubemap
     * @param {string} bottom The bottom side of the cubemap
     * @param {string} front The front side of the cubemap
     * @param {string} back The back side of the cubemap
     */
    constructor(left, right, top, bottom, front, back) {
        super();

        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.front = front;
        this.back = back;
    }

    /**
     * Generate a texture for this background
     * @param {WebGLRenderer} renderer The renderer
     * @returns {Promise} A promise which resolves when loading finishes
     */
    generate(renderer) {
        return new Promise(resolve => {
            Globals.CUBE_MAP_CACHE.loadFromArray([
                this.left,
                this.right,
                this.top,
                this.bottom,
                this.front,
                this.back
            ]).then(texture => {
                this.texture = texture;

                resolve();
            });
        });
    }
}